import { createAsyncThunk } from '@reduxjs/toolkit'
import axiosInstance from 'src/utils/axios'
import { backend, backendShop } from 'src/config'
import { PACKAGE_STATUSES } from 'src/constants'
import { getDateWitchRightFormat } from 'src/utils/date'
import { filterGoodsById, setGoods } from '.'

// const getImages = async (picturesKeys, requestUrl) => {
//   const mapToPromise = picturesKeys?.map((imageKey) =>
//     axiosInstance.get(`${requestUrl}${imageKey}`)
//   )
//   const response = await Promise.allSettled(mapToPromise)
//   const fulfilledData = response.filter((image) => image.status === 'fulfilled')

//   return fulfilledData
// }

// export const fetchPhotoData = (key) =>
//   createAsyncThunk(key, async (picturesKeys, { rejectWithValue }) => {
//     if (!picturesKeys) return []
//     try {
//       const requestUrl = `${backend}/api/image?imageName=`
//       const fulfilledData = await getImages(picturesKeys, requestUrl)
//       if (fulfilledData?.length) {
//         const readyPictures = fulfilledData.map((resp) => ({
//           src: `data:image/png;base64,${resp.value.data}`,
//           imageKey: resp.value.config.url?.replace(requestUrl, '')?.trim(),
//         }))
//         return readyPictures
//       }
//       return rejectWithValue([], 'Something went wrong')
//     } catch (err) {
//       return rejectWithValue([], err)
//     }
//   })

// export const fetchPhotoReportData = fetchPhotoData('FETCH_PHOTO_REPORT_DETAILS')

// export const fetchPhotoDefectData = fetchPhotoData('FETCH_PHOTO_DEFECT_DETAILS')

// export const fetchCargoPhotoData = fetchPhotoData('FETCH_CARGO_PHOTO_DATA')

export const fetchGoods = createAsyncThunk(
  'GET_GOODS',
  async ({ id }, { rejectWithValue, dispatch }) => {
    console.log(44)
    try {
      const { data } = await axiosInstance.get(`${backend}/api/goods/${id}`)
      dispatch(setGoods(data))
      return data
    } catch (err) {
      return rejectWithValue([], err)
    }
  }
)

export const updatePhotoPictures = createAsyncThunk(
  'UPDATE_PHOTO_REPORT_PICTURES',
  async (
    { availablePicturesKeys, id, keyForImageSave = 'photoReportUrl' },
    { rejectWithValue }
  ) => {
    try {
      const body = { [keyForImageSave]: availablePicturesKeys }
      await axiosInstance.put(`${backend}/api/goods/${id}`, body)
    } catch (err) {
      return rejectWithValue([], err)
    }
  }
)

export const duplicateGoodThunk = createAsyncThunk(
  'DUPLICATE_GOOD',
  async ({ id }, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.post(
        `${backend}/api/goods/duplicate/${id}`
      )
      return data
    } catch (err) {
      return rejectWithValue(err)
    }
  }
)

export const getReadyGoods = createAsyncThunk(
  'GET_READY_GOODS',
  async ({ id }, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.get(
        `${backend}/api/readyGoods/${id}`
      )
      return data
    } catch (err) {
      return rejectWithValue(err)
    }
  }
)

export const deleteGoodsParcelOneClick = createAsyncThunk(
  'DELETE_GOODS_PARCEL_ONE_CLICK',
  async ({ goodsId, enqueueSnackbar }) => {
    try {
      const response = await axiosInstance.put(
        `${backend}/api/readyGoods/${goodsId}/to-goods`
      )
      enqueueSnackbar('Готовый груз был преобразован в груз', {
        variant: 'success',
      })
      return response?.data
    } catch (err) {
      enqueueSnackbar('Мы не смогли превратить готовые груз в груз', {
        variant: 'error',
      })
      return
    }
  }
)

export const updateGoodThunk = createAsyncThunk(
  'UPDATE_GOOD',
  async ({ id, newData, enqueueSnackbar }) => {
    try {
      const { data } = await axiosInstance.put(
        `${backend}/api/goods/${id}`,
        newData
      )
      enqueueSnackbar('Изменения в грузах были обновлены', {
        variant: 'success',
      })
      return data
    } catch (err) {
      return enqueueSnackbar('Что-то пошло не так', {
        variant: 'error',
      })
    }
  }
)

export const removeGoodFromParcel = createAsyncThunk(
  'REMOVE_GOOD_FROM_PARCEL',
  async ({ goodsId }, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.put(
        `${backend}/api/goods/remove-from-parcel/${goodsId}`
      )
      return { goodsId, data }
    } catch (err) {
      return rejectWithValue(err)
    }
  }
)

const buildProductDescriptionBody = (good) => {
  if (!good) return {}

  return {
    id: good.id,
    qty: good.qtyCustom ?? good.qty,
    name: good.name,
    size: good.size,
    color: good.color,
    material: good.material,
    description: good.descriptionCustom ?? good.description,
    descriptionForRegistry: good.descriptionForRegistry,
    parcelId: good.parcelId,
    info_url: good.info_url,
    imageUrl: good.picture,
    commentProduct: good.commentProduct,
    cost: good.costCustom ?? good.cost,
    weight: good.weight,
    goodsType: good.goodsType,
    goodCategory: good.goodCategory,
    goodHazardCategory: good.goodHazardCategory,
    isDangerous: good.isDangerous,
    customsName: good.customsName,
    descriptionCustom: good.descriptionCustom,
    acceptCount: good.acceptCount,
    acceptTime: good.acceptTime,
  }
}

export const fetchProductDescription = createAsyncThunk(
  'FETCH_PRODUCT_DESCRIPTION',
  async ({ good, enqueueSnackbar }, { rejectWithValue }) => {
    if (!good?.id) {
      return rejectWithValue('GOOD_ID_IS_REQUIRED')
    }

    try {
      const body = buildProductDescriptionBody(good)
      const { data } = await axiosInstance.post(
        `${backendShop}/api/product-description`,
        body
      )

      enqueueSnackbar('Описание товара обновлено', {
        variant: 'success',
      })

      return data
    } catch (error) {
      const errorMessage =
        error?.message || 'Мы не смогли обновить описание товара'

      enqueueSnackbar(errorMessage, {
        variant: 'error',
      })

      return rejectWithValue(error)
    }
  }
)

export const fetchGoodsOldThenFiveDays = createAsyncThunk(
  'FETCH_GOODS_OLD_THEN_FIVE_DAYS',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `${backend}/api/goods?statusId=${
          PACKAGE_STATUSES.WAITING
        }&offset=200&isFromOrderUnit=true&to=${getDateWitchRightFormat(6)}`
      )
      return response.data
    } catch (error) {
      console.error('Error in FETCH_ORDER_UNIT_DETAILS', error)
      return rejectWithValue({}, error)
    }
  }
)

export const deleteGoodsPictures = createAsyncThunk(
  'DELETE_GOODS_PHOTO',
  async ({ imageName, imagePropertyName, id }, { rejectWithValue }) => {
    try {
      await axiosInstance.delete(
        `${backend}/api/google-cloud/image?filename=${imageName}`
      )
      const { data } = await axiosInstance.delete(
        `${backend}/api/goods/picture/${id}?goodsImageFieldName=${imagePropertyName}&imageName=${imageName}`
      )
      return data
    } catch (err) {
      return rejectWithValue([], err)
    }
  }
)

export const removeHazardCategory = createAsyncThunk(
  'REMOVE_HAZARD_CATEGORY',
  async (
    { id, hazardCategoryId, query, enqueueSnackbar },
    { rejectWithValue }
  ) => {
    try {
      const baseUrl = `${backend}/api/goods/remove/hazard-category/${id}`
      let url = baseUrl

      if (query) {
        const normalizedQuery = query.startsWith('?') ? query : `?${query}`
        url = `${baseUrl}${normalizedQuery}`
      } else if (hazardCategoryId !== undefined) {
        const searchParams = new URLSearchParams({
          hazardCategoryId,
        })
        url = `${baseUrl}?${searchParams.toString()}`
      }

      const { data } = await axiosInstance.put(url)
      return data
    } catch (err) {
      if (enqueueSnackbar) {
        enqueueSnackbar(
          err?.message || 'Не удалось удалить категорию опасности',
          {
            variant: 'error',
          }
        )
      }
      return rejectWithValue([], err)
    }
  }
)

export const deleteOrders = createAsyncThunk(
  'orders/deleteOrders',
  async ({ items }, { rejectWithValue }) => {
    const deletePromises = items?.map((el) =>
      axiosInstance.delete(`${backend}/api/goods/${el.id}`)
    )

    try {
      await Promise.all(deletePromises)
      return 'success'
    } catch (error) {
      console.error('Error occurred in delete orders: ', error)
      return rejectWithValue([], error)
    }
  }
)

export const deleteSupportGoods = createAsyncThunk(
  'orders/deleteSupportGoods',
  async ({ items }, { rejectWithValue }) => {
    const deletePromises = items?.map((el) =>
      axiosInstance.delete(`${backend}/api/goods/support/${el.id}`)
    )

    try {
      await Promise.all(deletePromises)
      return 'success'
    } catch (error) {
      console.error('Error occurred in support delete goods: ', error)
      return rejectWithValue([], error)
    }
  }
)

export const saveImageToGoogleCloud = async (file) => {
  if (!file) return
  const formData = new FormData()
  formData.append('file', file)
  try {
    const image = await axiosInstance.post(
      `${backend}/api/google-cloud/image`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    )

    return image.data
  } catch (error) {
    console.log('🚀 ~ saveImageToGoogleCloud ~ error:', error)
  }
}

export const fetchGoodsByStatus = createAsyncThunk(
  'FETCH_ALL_GOODS_BY_STATUS',
  async (
    { statusId, offset = '1000', page = 1, query = '' },
    { rejectWithValue }
  ) => {
    try {
      const response = await axiosInstance.get(
        `${backend}/api/goods?statusId=${statusId}&offset=${offset}&page=${page}${query}`
      )

      if (response.data) {
        return response.data
      }
    } catch (error) {
      console.error('Error in fetchGoodsByStatus: ', error)
      return rejectWithValue(error)
    }
  }
)

export const fetchAwaitingInStoreGoods = createAsyncThunk(
  'FETCH_AWAITING_IN_STORE_GOODS',
  async ({ offset = '50', page = 1, query = '' } = {}, { rejectWithValue }) => {
    try {
      const normalizedQuery = query
        ? `&${String(query).replace(/^\?/, '')}`
        : ''
      const response = await axiosInstance.get(
        `${backend}/api/goods/awaiting-in-store?offset=${offset}&page=${page}${normalizedQuery}`
      )

      if (response.data) {
        return response.data
      }
    } catch (error) {
      console.error('Error in fetchAwaitingInStoreGoods: ', error)
      return rejectWithValue(error)
    }
  }
)

export const fetchAwaitingInStoreExtendedGoods = createAsyncThunk(
  'FETCH_AWAITING_IN_STORE_EXTENDED_GOODS',
  async ({ offset = '50', page = 1, query = '' } = {}, { rejectWithValue }) => {
    try {
      const normalizedQuery = query
        ? `&${String(query).replace(/^\?/, '')}`
        : ''
      const response = await axiosInstance.get(
        `${backend}/api/goods/awaiting-in-store-extended?offset=${offset}&page=${page}${normalizedQuery}`
      )

      if (response.data) {
        return response.data
      }
    } catch (error) {
      console.error('Error in fetchAwaitingInStoreExtendedGoods: ', error)
      return rejectWithValue(error)
    }
  }
)

export const fetchAwaitingInStoreGoodById = createAsyncThunk(
  'FETCH_AWAITING_IN_STORE_GOOD_BY_ID',
  async ({ goodsId }, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.get(
        `${backend}/api/goods/awaiting-in-store/${goodsId}`
      )
      return data
    } catch (error) {
      console.error('Error in fetchAwaitingInStoreGoodById: ', error)
      return rejectWithValue(error)
    }
  }
)

export const fetchAwaitingInStoreById = createAsyncThunk(
  'FETCH_AWAITING_IN_STORE_BY_ID',
  async ({ id }, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.get(
        `${backend}/api/goods/awaiting-in-store/${id}`
      )
      return data
    } catch (error) {
      console.error('Error in fetchAwaitingInStoreById: ', error)
      return rejectWithValue(error)
    }
  }
)

export const disposeAwaitingInStoreGood = createAsyncThunk(
  'DISPOSE_AWAITING_IN_STORE_GOOD',
  async ({ goodsId, body }, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.put(
        `${backend}/api/goods/dispose-of/awaiting-in-store/${goodsId}`,
        body
      )
      return data
    } catch (error) {
      console.error('Error in disposeAwaitingInStoreGood: ', error)
      return rejectWithValue(error)
    }
  }
)

export const fetchGoodsByQuery = createAsyncThunk(
  'FETCH_ALL_GOODS_BY_QUERY',
  async ({ query, offset = '1000', page = 1 }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `${backend}/api/goods?${query}&offset=${offset}&page=${page}`
      )

      if (response.data) {
        return response.data
      }
    } catch (error) {
      console.error('Error in fetchGoodsByStatus: ', error)
      return rejectWithValue(error)
    }
  }
)

export const fetchGoodsByParcelId = createAsyncThunk(
  'FETCH_ALL_GOODS_BY_PARCEL_ID',
  async (
    { parcelId, enqueueSnackbar, offset = '1000' },
    { rejectWithValue }
  ) => {
    try {
      const response = await axiosInstance.get(
        `${backend}/api/goods?parcelId=${parcelId}&offset=${offset}`
      )
      if (response.data) {
        return response.data.data
      }
    } catch (error) {
      enqueueSnackbar('Мы не смогли получить товар.', {
        variant: 'error',
      })
      return rejectWithValue(error)
    }
  }
)

export const fetchGoodById = createAsyncThunk(
  'FETCH_GOOD_BY_ID',
  async ({ goodId, query = '' }, { rejectWithValue }) => {
    try {
      const normalizedQuery = query
        ? `${String(query).startsWith('?') ? '' : '?'}${String(query).replace(
            /^[?&]/,
            ''
          )}`
        : ''

      const { data } = await axiosInstance.get(
        `${backend}/api/goods/${goodId}${normalizedQuery}`
      )
      return data
    } catch (error) {
      return rejectWithValue(error)
    }
  }
)

// export const fetchGoodsByDate = createAsyncThunk(
//   'FETCH_GOOD_DATE',
//   async ({ enqueueSnackbar, offset = 5000 }) => {
//     try {
//       const { data } = await axiosInstance.get(
//         `${backend}/api/goods?from=2025-01-01 00:00:00.164
//         &offset=${offset}&isRegisteredAtCustoms=false`
//       );
//       return data;
//     } catch (error) {
//       console.log(error, 'error');
//       enqueueSnackbar('Что-то пошло не так', {
//         variant: 'error'
//       });
//     }
//   }
// );

export const fetchGoodParcelByID = createAsyncThunk(
  'FETCH_GOOD_PARCEL_BY_ID',
  async ({ parcelId }, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.get(
        `${backend}/api/goods/parcel/${parcelId}?offset=100000`
      )
      return data
    } catch (error) {
      return rejectWithValue([], error)
    }
  }
)

export const fetchGoodStatusHistory = createAsyncThunk(
  'FETCH_GOOD_STATUS_HISTORY',
  async ({ goodId }, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.get(
        `${backend}/api/goodsStatusHistory/${goodId}`
      )

      return data
    } catch (error) {
      console.log('Error while FETCH_GOOD_STATUS_HISTORY', error)
      return rejectWithValue(error)
    }
  }
)

export const cancelGoods = createAsyncThunk(
  'CANCEL_GOODS',
  async ({ goodsId, enqueueSnackbar }, { dispatch, rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.delete(
        `${backend}/api/goods/cancel/${goodsId}`
      )
      enqueueSnackbar('Товар был успешно отменен', {
        variant: 'success',
      })
      dispatch(filterGoodsById({ goodsId }))
      return data
    } catch (error) {
      enqueueSnackbar('Что-то пошло не так', {
        variant: 'error',
      })
      return rejectWithValue(error)
    }
  }
)

export const fetchCargoDetails = createAsyncThunk(
  'FETCH_CARGO_DETAILS',
  async (declaration, { rejectWithValue }) => {
    try {
      const acceptTime = getDateWitchRightFormat(0)
      const response = await axiosInstance.post(
        `${backend}/api/goods/receive/${declaration}?statusId=5&acceptTime=${encodeURIComponent(
          acceptTime
        )}`
      )
      return response?.data
    } catch (error) {
      console.error('Error in FETCH_CARGO_DETAILS', error)
      return rejectWithValue({}, error)
    }
  }
)

export const putYiliGoods = createAsyncThunk(
  'PUT_YILI_GOODS',
  async ({ goodsId, enqueueSnackbar }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(
        `${backend}/api/yili/goods/${goodsId}`
      )
      enqueueSnackbar('Товар успешно зарегистрирован', {
        variant: 'success',
      })
      return response?.data
    } catch (error) {
      enqueueSnackbar('Мы не смогли зарегистрировать товар', {
        variant: 'error',
      })
      return rejectWithValue({}, error)
    }
  }
)

export const createWaifRegister = createAsyncThunk(
  'CREATE_WAIF_REGISTER',
  async ({ data, enqueueSnackbar = () => {} }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        `${backend}/api/goods/waif`,
        data
      )
      enqueueSnackbar('Товары зарегистрирован', { variant: 'success' })
      return response.data
    } catch (error) {
      enqueueSnackbar(error.message, { variant: 'error' })
      console.error('Error in CREATE_WAIF_REGISTER', error)
      return rejectWithValue({}, error)
    }
  }
)

export const fetchDeliveryTransaction = createAsyncThunk(
  'FETCH_WAIF_REGISTER',
  async (data, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(
        `${backend}/api/goods/deliveryTransaction/${data.goodIncomingDeclaration}?deliveryPriceInChina=${data.deliveryPriceInChina}`,
        data
      )
      return response?.data
    } catch (error) {
      console.error('Error in FETCH_CARGO_DETAILS', error)
      return rejectWithValue(error)
    }
  }
)

export const fetchChangeWeight = createAsyncThunk(
  'FETCH_CHANG_WEIGHT',
  async (
    { goodId, weight, enqueueSnackbar = () => {} },
    { rejectWithValue }
  ) => {
    try {
      const response = await axiosInstance.put(
        `${backend}/api/goods/${goodId}/weight?weight=${weight}`
      )
      enqueueSnackbar('Вес успешно изменен', {
        variant: 'success',
      })
      return response?.data
    } catch (error) {
      const errorMsg = error?.message || 'Мы не смогли изменить вес'
      enqueueSnackbar(errorMsg, {
        variant: 'error',
      })
      return rejectWithValue({}, error)
    }
  }
)

export const fetchGoodCellHistory = createAsyncThunk(
  'FETCH_GOOD_CELL_HISTORY',
  async ({ goodId }, { rejectWithValue }) => {
    try {
      console.log(666)
      const { data } = await axiosInstance.get(
        `${backend}/api/goods/storeCell/${goodId}`
      )
      return data
    } catch (error) {
      console.log('Error while FETCH_GOOD_CELL_HISTORY', error)
      return rejectWithValue(error)
    }
  }
)

export const fetchScanDates = createAsyncThunk(
  'FETCH_SCAN_DATES',
  async ({ trackNumber }, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.get(
        `${backend}/api/unknown-good/public/registration-dates?trackNumber=${encodeURIComponent(
          trackNumber
        )}`
      )
      return data
    } catch (error) {
      console.error('Error in FETCH_SCAN_DATES', error)
      return rejectWithValue({}, error)
    }
  }
)

export const yuTRegistrationGood = createAsyncThunk(
  'YU_T_REGISTRATION_GOOD',
  async ({ goodId }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        `${backend}/api/unitrade/register/goods/${goodId}`
      )

      return response?.data
    } catch (error) {
      return rejectWithValue({}, error)
    }
  }
)
